import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/research.css'
import {
  DailyMarket,
  Sector,
  Macroeconomic,
  Indicator,
  Equity,
  Bespoke,
  Archives,
} from '../components/ResearchAccordion';
import Password from '../components/Password';
import LogoutButton from '../components/LogoutButton'

export default class Research extends React.Component {


  constructor(props){
    super(props);
    this.state = {
      query: '', 
      passw: 'pass', 
      isVisible: false 
    };
  
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLogOff = this.handleLogOff.bind(this);
  }

  checkPassword(password){
    if(password === 'pass'){
      return true;
    }
    return false;
  }

  handleChange = (e) => {
    this.setState({
      query: e.target.value
    })
  }

  handleSubmit(e){
    e.preventDefault();
    this.setState({
      isVisible : this.checkPassword(this.state.query),
      query: ''
    });
  }

  handleLogOff(e){
    e.preventDefault();
    this.setState({
      isVisible : false,
    });
  }

  render() {
    
    const secretVisible = this.state.isVisible;
    let pageToDisplay;
    if(secretVisible){
      pageToDisplay = <Bespoke /> 
    }
    else{
      pageToDisplay = <Password password={this.state.query} onChange={this.handleChange} onSubmit={this.handleSubmit} />
    }

    return (
      <div className='research'>
        <header className="banner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6 col-md-7 col-xl-9">
                <div className='paginations'>
                  <div className="gray-button-sm">
                    <Link to='/'>Home</Link>
                  </div>
                  <div className="blue-button-sm">
                    <Link to='/research'>Research</Link>
                  </div>
                </div>
                <div className="header-text">
                  <h1 className='bold'>Research</h1>
                </div>
              </div>
              <div className="d-none d-sm-block col-sm-6 col-md-5 col-xl-3">
                <div className="card light-blue-bg">
                  <div className="column white-text">
                    <div className="card-body">
                      {/* <span>Daily Report</span> */}
                      <p className="block-heading bold">Daily Report</p>
                      <p>19 May 2019</p>

                      <Link to="" className="white-text"><i className='fa fa-arrow-down' aria-hidden="true"></i></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="section-alt research-accordion" >
          <div className="d-block d-sm-none col-sm-6 col-md-5 col-xl-3 pt-5 px-0">
            <div className="card light-blue-bg">
              <div className="column white-text">
                <div className="card-body">
                  <span>Daily Report</span>
                  <p className="block-heading bold">Daily Report</p>
                  <p>19 May 2019</p>

                  <Link to="" className="white-text"><i className='fa fa-arrow-down' aria-hidden="true"></i></Link>
                </div>
              </div>
            </div>
          </div>
          <div className="researchaccordion">
            <DailyMarket />
            <Macroeconomic />
            <Equity />
            <Sector />
            {pageToDisplay}
            {this.state.isVisible ? <LogoutButton onTakeMeBackClicked={this.handleLogOff} /> : null}
            <Indicator />
            <Archives />
          </div>
        </div>
      </div>
    );
  }
}